"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styledTextDefinedFontWeight = exports.styledTextDefinedSize = exports.styledTextDefinedColor = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var index_1 = require("../../styles/index");
var styledTextDefinedSize = {
    unset: 'unset',
    sm: '1.2rem',
    md: '1.4rem',
    lg: '1.6rem',
    xl: '1.8rem',
    xxl: '2.0rem',
};
exports.styledTextDefinedSize = styledTextDefinedSize;
var styledTextDefinedColor = __assign({ unset: 'unset' }, index_1.theme.colors);
exports.styledTextDefinedColor = styledTextDefinedColor;
var styledTextDefinedFontWeight = __assign({ unset: 'unset' }, index_1.theme.fontWeight);
exports.styledTextDefinedFontWeight = styledTextDefinedFontWeight;
var StyledText = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  font-size: ",
    ";\n  color: ",
    ";\n  font-weight: ",
    ";\n"])), function (_a) {
    var size = _a.size;
    return styledTextDefinedSize[size] || size;
}, function (_a) {
    var color = _a.color;
    return styledTextDefinedColor[color] || color;
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return "" + (styledTextDefinedFontWeight[fontWeight] || fontWeight);
});
StyledText.defaultProps = {
    size: 'unset',
    color: 'unset',
    fontWeight: 'unset',
};
exports.default = StyledText;
var templateObject_1;
//# sourceMappingURL=StyledText.js.map